/*!
 * WowStore — Continue browsing
 * Client-side personalization. localStorage only. No cookies, no fetch, no analytics.
 *
 * Storage shape:
 *   key: wowstore.last_viewed_products
 *   value: JSON array of { handle, title, image, ts } — max 5, deduped by handle, MRU first
 *
 * Behavior:
 *   - On any product page: record the current product (handle, title, image, ts).
 *   - On 2nd+ visit, render the most-recent OTHER product into the section's <aside>.
 *   - Expire entries older than max_age_days (data-attribute on the section).
 *   - If hide_if_same_product=1 and only candidate is current handle → stay hidden.
 *   - Section renders only on product templates (Liquid-gated); JS guards too.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'wowstore.last_viewed_products';
  var MAX_ENTRIES = 5;

  function safeLocalStorage() {
    try {
      var t = '__wow_cb_test__';
      window.localStorage.setItem(t, '1');
      window.localStorage.removeItem(t);
      return window.localStorage;
    } catch (e) {
      return null;
    }
  }

  function readEntries(store) {
    try {
      var raw = store.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeEntries(store, entries) {
    try {
      store.setItem(STORAGE_KEY, JSON.stringify(entries));
    } catch (e) {
      // quota exceeded / private mode — silently degrade
    }
  }

  function pruneExpired(entries, maxAgeDays) {
    if (!entries || !entries.length) return [];
    var cutoff = Date.now() - (maxAgeDays * 86400000);
    return entries.filter(function (e) {
      return e && typeof e === 'object' && e.handle && typeof e.ts === 'number' && e.ts >= cutoff;
    });
  }

  function recordCurrent(store, entry, maxAgeDays) {
    var entries = pruneExpired(readEntries(store), maxAgeDays);
    // Dedupe by handle — remove any existing match
    entries = entries.filter(function (e) { return e.handle !== entry.handle; });
    // Most-recent first
    entries.unshift(entry);
    if (entries.length > MAX_ENTRIES) entries = entries.slice(0, MAX_ENTRIES);
    writeEntries(store, entries);
  }

  function pickCandidate(store, currentHandle, hideIfSame, maxAgeDays) {
    var entries = pruneExpired(readEntries(store), maxAgeDays);
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (!e || !e.handle || !e.title) continue;
      if (hideIfSame && e.handle === currentHandle) continue;
      return e;
    }
    return null;
  }

  function detectCurrentProduct(section) {
    var handle = section.getAttribute('data-current-handle') || '';
    // Title: prefer the OG title meta, then document.title, then product title element.
    var title = '';
    var og = document.querySelector('meta[property="og:title"]');
    if (og && og.getAttribute('content')) title = og.getAttribute('content').trim();
    if (!title) {
      var h1 = document.querySelector('.product__title, h1.product-title, .product-single__title, h1');
      if (h1 && h1.textContent) title = h1.textContent.trim();
    }
    if (!title) title = (document.title || '').split('–')[0].split('|')[0].trim();

    // Image: prefer og:image meta, then first product gallery image.
    var image = '';
    var ogi = document.querySelector('meta[property="og:image"]');
    if (ogi && ogi.getAttribute('content')) image = ogi.getAttribute('content');
    if (!image) {
      var img = document.querySelector('.product__media img, .product-gallery img, .product-media img, img[itemprop="image"]');
      if (img) image = img.currentSrc || img.src || img.getAttribute('data-src') || '';
    }

    return { handle: handle, title: title, image: image, ts: Date.now() };
  }

  function hydrate(section) {
    var store = safeLocalStorage();
    if (!store) return;

    var currentHandle = section.getAttribute('data-current-handle') || '';
    var hideIfSame = section.getAttribute('data-hide-if-same-product') === '1';
    var maxAgeDays = parseInt(section.getAttribute('data-max-age-days'), 10);
    if (!maxAgeDays || isNaN(maxAgeDays)) maxAgeDays = 14;

    // 1) Pick candidate (BEFORE recording current, so the new entry isn't surfaced as itself)
    var candidate = pickCandidate(store, currentHandle, hideIfSame, maxAgeDays);

    // 2) Record current product
    if (currentHandle) {
      var current = detectCurrentProduct(section);
      if (current.handle && current.title) {
        recordCurrent(store, current, maxAgeDays);
      }
    }

    // 3) If no candidate, stay hidden
    if (!candidate) return;

    // 4) Hydrate markup
    var link = section.querySelector('[data-cb-link]');
    var thumb = section.querySelector('[data-cb-thumb]');
    var titleEl = section.querySelector('[data-cb-title]');
    if (!link || !titleEl) return;

    link.setAttribute('href', '/products/' + candidate.handle);
    titleEl.textContent = candidate.title;
    if (thumb && candidate.image) {
      // Use the existing storefront convention — image URLs already include sizing/CDN params from og:image.
      thumb.style.backgroundImage = "url('" + candidate.image.replace(/'/g, "%27") + "')";
    }

    // Dismiss button → hide for this session
    var dismiss = section.querySelector('[data-cb-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function (ev) {
        ev.preventDefault();
        section.hidden = true;
        section.style.display = 'none';
      });
    }

    // Reveal
    section.hidden = false;
    section.style.display = '';
  }

  function init() {
    var sections = document.querySelectorAll('[data-section-type="continue-browsing"]');
    for (var i = 0; i < sections.length; i++) {
      try { hydrate(sections[i]); } catch (e) { /* never break the PDP */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
